import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DialogHandler } from "./DialogHandler";

const CustomDialog = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (searchParams.get("dialog") == "open") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [searchParams]);
  const handleClose = () => {
    setSearchParams({});
  };

  const renderHeader = () => {
    switch (searchParams.get("for")) {
      case "timings":
        return "Timings";
      case "services":
        return "Service";
      default:
        return "Default";
    }
  };

  const renderAction = () => {
    switch (searchParams.get("action")) {
      case "edit":
        return "Edit";
      case "view":
        return "View";
      case "add":
        return "Add";
      default:
        return "Default";
    }
  };

  return (
    <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClose={handleClose}>
      <DialogTitle>{`${renderAction()} ${renderHeader()}`}</DialogTitle>

      <DialogHandler
        subject={searchParams.get("for")}
        action={searchParams.get("action")}
        id={searchParams.get("id")}
      />
    </Dialog>
  );
};

export { CustomDialog };
